import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumMenuService } from 'src/commons/services/breadCrumb/breadcrum-menu.service';
import { LoginService } from '../login/login.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
/**
 * Componente de encabezado.
 */
export class HeaderComponent {
  route: Router;

  //Boolean para comprobar si es empresa
  empresaB?: boolean;

  //Boolean para comprobar si es AESAN
  esAESAN?: boolean;

  //Boolean para comprobar si es cartera
  esCarteraB?: boolean;
  esCarteraLectura?: boolean;

  //Boolean para comprobar si es Admin
  esAdmin?: boolean;

  roleString: string = "";

  constructor (private router: Router, private menu: BreadcrumMenuService,private loginService:LoginService) {
    this.route = router;

    this.menu.Header = this;

    loginService.onLoginInfoChanged().subscribe((loginInfo) => {
      if(loginInfo != null){

        this.empresaB = this.loginService.isEmpresa();
        this.esAESAN = this.loginService.isAESAN();
        this.esCarteraB = this.loginService.isCartera();
        this.esCarteraLectura = this.loginService.isCarteraLectura();
        this.esAdmin = this.loginService.isAdmin();

    if(this.esAESAN){
        this.roleString = "AESAN";
    }else if(this.esCarteraB || this.esCarteraLectura){
      this.roleString = "CARTERA";
    }else if(this.empresaB){
      this.roleString = "EMPRESA";
    } else if(this.esAdmin){
      this.roleString = "ADMIN";
    }
  }
  });


}

  esEmpresa() {
    this.empresaB = true
    this.esAESAN = false;
    this.esCarteraB = false;
  }

  esAesan(){
    this.empresaB = false;
    this.esAESAN = true;
    this.esCarteraB = false;
  }

  esCartera(){
    this.empresaB = false;
    this.esAESAN = true;
    this.esCarteraB = true;
  }
}
